// react
import { createContext, Dispatch, SetStateAction } from 'react';

// types
import { Entity, User } from './@types';

// ui
import { BannerProps } from './components/ui/Banner/Banner';

export interface ContextBannerProps {
	banner: BannerProps | null;
	setBanner: Dispatch<SetStateAction<BannerProps | null>>;
}

export const ContextBanner = createContext<ContextBannerProps>({
	banner: null,
	setBanner: (banner) => {
		console.log(banner);
	},
});

export interface ContextUserProps {
	user: User | null;
	setUser: Dispatch<SetStateAction<User | null>>;
}

export const ContextUser = createContext<ContextUserProps>({
	user: null,
	setUser: () => {
		console.log('SET USER');
	},
});

export interface ContextUserEntityProps {
	userEntity: Entity | null;
	setUserEntity: Dispatch<SetStateAction<Entity | null>>;
}

export const ContextUserEntity = createContext<ContextUserEntityProps>({
	userEntity: null,
	setUserEntity: () => {
		console.log('SET USER ENTITY');
	},
});
